import styled from 'styled-components/macro';
import { LinkWithSearchParams as Link } from 'components/base/Link/Link';

import { stripUnit } from 'polished';

import modularScale from 'styles/helpers/modular-scale';
import { primaryTypography } from 'styles/global/typography/typography';

import Artwork from 'components/base/Artwork/Artwork';

export const ArtworkWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing.medium};
  flex-shrink: 0;
  width: ${modularScale(6)};
`;

export const StyledArtwork = styled(Artwork)`
  width: ${modularScale(6)} !important;
  height: ${modularScale(6)} !important;
`;

export const Entity = styled.div<any>`
  display: flex;
  /** This flex declaration is needed so that the table wraps properly in IE11 */
  ${({ minWidth }) => (minWidth ? 'width: fit-content;' : 'flex: 1 1 100%;')}
  align-items: center;
`;

export const EntityLink = styled(Entity.withComponent(Link))<any>`
  transition: ${({ theme }) =>
    `background ${theme.transitionDuration} ${theme.timingFunction}`};

  ${ArtworkWrapper} {
    transition: ${({ theme }) =>
      `transform ${theme.transitionDuration} ${theme.timingFunction}`};
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.Sand};

    ${ArtworkWrapper} {
      transform: translateX(0.25em);
    }
  }

  &:active {
    background: ${({ theme }) => theme.LightGrey};
  }
`;

export const EntityTitle = styled('h3')`
  display: flex;
  align-items: center;
  font-weight: 600;
  color: ${({ theme }) => theme.DeepBlue};
  line-height: 1.2;
  margin: 0;
  font-size: 1em;

  &:not(:last-child) {
    margin-right: ${stripUnit(modularScale(-3))}rem;
  }
`;

export const EntityMetadata = styled('div')`
  ${primaryTypography};
`;

export const Tag = styled('span')`
  display: inline-block;
  padding: 3px 5px 2px;
  color: ${({ theme }) => theme.DeepBlue};
  border: 1px solid currentColor;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: ${stripUnit(modularScale(-2))}rem;
  letter-spacing: 0.05em;
  transform: translateY(-2px);
  line-height: 1;
`;

export const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const ReleaseTypeWrapper = styled('span')<any>`
  display: inline-block;
  font-size: 9px;
  letter-spacing: 0.82px;
  text-transform: uppercase;
  padding: 3px 5px 2px;
  border-radius: 2px;
  margin-left: 5px;
  color: ${({ releaseTypeColor }) =>
    releaseTypeColor ? releaseTypeColor : '#8da5bf'};
  border: solid 0.8px
    ${({ releaseTypeColor }) =>
      releaseTypeColor ? releaseTypeColor : '#8da5bf'};
  font-weight: 400;
  ${({ lineHeigh }) => (lineHeigh ? `line-height: ${lineHeigh}` : '')}
`;
